import APIFetcher from '../APIFetcher';

class BannerApi {
  static getBanners() {
    return APIFetcher.get('banner');
  }

  static saveUserBanner({userId, bannerSlug, dateDismissed, dateViewed}) {
    const body = {
      userId,
      bannerSlug,
      is_dismissed: dateDismissed,
      dateDismissed,
      dateViewed,
    };
    return APIFetcher.post(`user-banner/${bannerSlug}`, {
      payload: body
    });
  }
}

export default BannerApi;
